export enum CallCenterCallTypeEnum {
  Active = 'ATIVA',
  Receptive = 'RECEPTIVA',
  Return = 'RETORNO',
  ReturnNotSuccessful = 'RETORNO_NAO_SUCEDIDO',
  NotSuccessful = 'NAO_SUCEDIDA',
  QuestionMistake = 'ENGANO_DUVIDAS',
  Unknown = 'DESCONHECIDO',
}
